<div #card class="card transition" (click)="toggleActive(page, $event)" [class.active]="page.active">
  <h2 #transition class="transition" [style.top]="page.active ? 0 : cardHeight - transitionHeight - 50 + 'px'" [ngStyle]="setFontStyle()"
    [ngClass]="{'largeLabels': page.largeLabels}">{{page.title | i18n}}</h2>
  <p [ngClass]="{'largeDescription': page.largeLabels}">{{getDescription(page) | i18n}}</p>
  <div class="cta-container transition">
    <a [ngStyle]="setButtonStyle()" *ngIf="page.content" (click)="openModal()" class="cta">{{ 'std.details' | translate }}</a>
    <a [ngStyle]="setButtonStyle()" *ngIf="page.poiCategory || page.location" (click)="openMap()" class="cta">{{ 'std.map' | translate }}</a>
  </div>
  <div [ngStyle]="{ 'background-image': 'url(' + (page.image | i18n) + ')'}" class="card_circle transition"></div>
</div>
<custom-modal #modal></custom-modal>
